module.exports = __webpack_public_path__ + "img/kefuQRCode.6199f381.png";